import React, { Component } from "react";
import { ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { translate } from "react-i18next";

class DeleteMap extends Component {
  submitModal = () => {
    const { modalData } = this.props;
    if (modalData.deleteMap && modalData.id) {
      modalData.deleteMap(modalData.id);
    }
  };

  render() {
    const { toggleModal, t } = this.props;
    return (
      <React.Fragment>
        <ModalHeader toggle={toggleModal}>
          {t("dashboard.deleteMap")}
        </ModalHeader>
        <ModalBody>
          <p>{t("dashboard.areYouSureYouWantToeleteThisMap")}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={this.submitModal}>
            {t("dashboard.confirm")}
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            {t("dashboard.cancel")}
          </Button>
        </ModalFooter>
      </React.Fragment>
    );
  }
}

export default translate("translations")(DeleteMap);
